import { useContactType } from "@/api/services/admin/contact-type";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { COMPANY_CONTAINER } from "@/constants/ui";
import { ContactTypeForm } from "@/features/contact/components/ContactTypeForm";
import { convertContactTypeResToForm } from "@/features/contact/utils/convert";
import { Stack } from "@mui/material";
import { FC } from "react";

type TContactTypeEditPageProps = {
  isCompany: boolean;
};

export const ContactTypeEditPage: FC<TContactTypeEditPageProps> = ({ isCompany }) => {
  const { data: contactTypeResult, isLoading } = useContactType();
  const contactTypeData = contactTypeResult?.data;

  if (isLoading || !contactTypeData) return <LoadingPage />;

  return (
    <Stack>
      <TopPage title="お問い合わせ管理" enablePageBack={false} />
      <Stack maxWidth={COMPANY_CONTAINER}>
        <ContactTypeForm isCompany={isCompany} previousData={convertContactTypeResToForm(contactTypeData)} />
      </Stack>
    </Stack>
  );
};
